import axios from "axios";

import env from "variables/config";
import { errorHandler } from "./utils";

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const getProjects = async () => {
    const res = await axios.get("/project", config()).catch(errorHandler);
    return res.data;
};

export const getProject = async (projectId: string) => {
    const res = await axios
        .get("/project/" + projectId, config())
        .catch(errorHandler);
    return res.data;
};

export const updateProject = async (data: any) => {
    const res = await axios
        .put("/project/", data, config())
        .catch(errorHandler);
    return res.data;
};

export const createProject = async (name: string) => {
    const res = await axios
        .post(
            "/project",
            {
                name: name,
                projectId: name.replaceAll(" ", "-").toLowerCase(),
            },
            config(),
        )
        .catch(errorHandler);
    return res.data;
};
